import api from './apiService'; 

// ✅ Upload Logo Image (form-data based)
export const AddLogoImage = async (formdata) => {
  try {
    const response = await api.post('/Home/UploadLogoImage', formdata);
    return response.data;
  } catch (error) {
    console.log("Add Logo error", error);
    throw error;
  }
};

// ✅ Get Logo Image
export const GetLogoImage = async (LabID) => {
  try {
    const response = await api.get('/Home/GetLogoImage', {
      params: { LabID },
    });
    return response.data;
  } catch (error) {
    console.log("Get Logo error", error);
    throw error;
  }
};

// ✅ Add Doctor Info
export const AddDrInfo = async (DrData) => {
  try {
    const response = await api.post('/Home/AddDoctorsInfo', {
      drname: DrData.drname,
      designation: DrData.designation,
      description: DrData.description,
      address: DrData.address,
      laboratoryid: DrData.laboratoryid ?? sessionStorage.getItem('LabID'),
    });
    return response.data;
  } catch (error) {
    console.log("Add Doctor Info error", error);
    throw error;
  }
};

// ✅ Add Template Setting
export const ADDTEMPLATESETTING = async (TEMPSET) => {
  try {
    const response = await api.post('/Home/AddTemplateSetting', {
      fontfamily: TEMPSET.fontfamily,
      fontsize: TEMPSET.fontsize,
      fontweight: '',
      labid: TEMPSET.LabID ?? sessionStorage.getItem('LabID'),
      electronicSignatureMsg: TEMPSET.electronicSignatureMsg ?? "",
    });
    return response.data;
  } catch (error) {
    console.log("Add Template error", error);
    throw error;
  }
};

// ✅ Get Doctor Info
export const GetDoctorInfo = async (LabID) => {
  try {
    const response = await api.get('/Home/GetDoctorInfo', {
      params: { LabID },
    });
    return response.data;
  } catch (error) {
    console.log("Get Doctor Info error", error);
    throw error;
  }
};

// ✅ Delete Doctor Info
export const DeleteDrInfo = async (LabiD, DRID) => {
  try {
    const response = await api.delete('/Home/DeleteDoctorInfo', {
      params: { LabiD, DRID },
    });
    return response.data;
  } catch (error) {
    console.log("Delete Doctor Info error", error);
    throw error;
  }
};

export const GetFontStyles = async (Labid) => {
  try {
    const response = await api.get(`/Home/GetTemplateSettings`, {
      params: { LabID: Labid },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};